// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"774":"af0f3192","854":"762e3c82"}[chunkId] + ".chunk.js";
};